import i18n from '@signavio/i18n';
import { StringUtils } from '@signavio/effektif-commons';
export default function link({
  value
}) {
  if (!value) {
    return [];
  }
  if (!StringUtils.validateUrl(value)) {
    return [i18n('Please enter a valid URL.')];
  }
  return [];
}